import { createFileRoute } from "@tanstack/react-router";
import { Header } from "@/components/rawan/Header";
import { Footer } from "@/components/rawan/Footer";
import { EditableStaticPage } from "@/components/rawan/EditableStaticPage";

export const Route = createFileRoute("/privacy")({
  head: () => ({
    meta: [
      { title: "سياسة الخصوصية — Rawan UI" },
      { name: "description", content: "سياسة الخصوصية الخاصة بموقع Rawan UI لعرض الأفلام والمسلسلات." },
    ],
  }),
  component: PrivacyPage,
});

function PrivacyPage() {
  return (
    <div className="min-h-dvh flex flex-col">
      <Header />
      <main className="flex-1 container mx-auto px-4 py-12 max-w-3xl">
        <EditableStaticPage
          pageKey="privacy"
          titleAr="سياسة الخصوصية"
          titleEn="Privacy Policy"
          titleFr="Politique de confidentialité"
          defaultParagraphsAr={[
            "## نظرة عامة\n\nنحترم خصوصيتك ولا نجمع أي بيانات شخصية إلا ما هو **ضروري** لتشغيل الموقع، مثل تفضيلات اللغة والمظهر والقوائم المحفوظة محلياً في متصفحك.",
            "## ملفات تعريف الارتباط\n\nقد نستخدم ملفات تعريف الارتباط (Cookies) لتحسين تجربتك، ولن نشارك أي معلومات مع أطراف ثالثة دون موافقتك.",
            "## التواصل\n\nلأي استفسار حول الخصوصية، تواصل معنا عبر [صفحة الاتصال](/contact).",
          ]}
          defaultParagraphsEn={[
            "## Overview\n\nWe respect your privacy and only store what's **needed** to run the site — language, theme, and saved lists are kept locally in your browser.",
            "## Cookies\n\nWe may use cookies to improve your experience and will not share information with third parties without your consent.",
            "## Contact\n\nFor any privacy questions, please use the [contact page](/contact).",
          ]}
          defaultParagraphsFr={[
            "## Vue d'ensemble\n\nNous respectons votre vie privée et ne conservons que ce qui est **nécessaire** au fonctionnement du site : langue, thème et listes sauvegardées localement dans votre navigateur.",
            "## Cookies\n\nNous pouvons utiliser des cookies pour améliorer votre expérience et ne partagerons aucune information avec des tiers sans votre consentement.",
            "## Contact\n\nPour toute question, utilisez la [page de contact](/contact).",
          ]}
        />
      </main>
      <Footer />
    </div>
  );
}
